import { useStopLists, useStopListSettings } from "@/api/stop-list.api";
import { CampaignStopWindow } from "@/components/stop-lists/CampaignStopWindow";
import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";

export const Route = createFileRoute(
  "/_dashboard/campaigns/setup/define/stop-lists",
)({
  component: RouteComponent,
  loader: () => ({
    showCampaignSetupBottomBar: false,
  }),
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  const { useStepper } = Route.useRouteContext();
  const { data: stopLists } = useStopLists();
  const stopListSetting = useStopListSettings();

  const stepper = useStepper();

  const onSubmit = useCallback(
    (data: string[]) => {
      stepper.setContext((prev) => ({
        ...prev,
        stopLists:
          stopLists?.filter((sL) =>
            data.some((i) => i === sL.uniqueId.toString()),
          ) ?? [],
      }));

      navigate({
        to: "/campaigns/setup/define",
      });
    },
    [navigate, stepper, stopLists],
  );

  return (
    <CampaignStopWindow
      isCreating={true}
      currentStopLists={stepper.context.stopLists ?? []}
      onSubmit={onSubmit}
      settings={stopListSetting.data}
      stopLists={stopLists}
      backLinkOptions={{
        to: "/campaigns/setup/define",
      }}
    />
  );
}
